import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Info from "./Info";
import { formatDateTime } from "../../../../../utils/dateFormat";

// PDF Styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 30,
  },
  table: {
    display: "table",
    width: "auto",
    border: "1px solid #bfbfbf",
    borderBottom: "",
  },
  tableRow: {
    borderBottom: "1px solid #dfdfdf",
    flexDirection: "row",
  },
  tableCol: {
    width: "100%",
    padding: 5,
  },
  tableHeader: {
    backgroundColor: "#003366",
    color: "#ffffff",
    padding: 5,
    fontWeight: "bold",
  },
  tableCell: {
    fontSize: ".15in",
    textAlign: "center",
  },
  disclaimer: {
    marginTop: 20,
    fontSize: 12,
    textAlign: "start",
    fontStyle: "italic",
  },
});

// PDF Document layout
const MyDocument = ({ searchLog, user }) => {
  const data = [
    {
      searchedName: `${searchLog?.searched_company || ""}`,
      client: searchLog?.searcher?.affiliate?.name,
      // inquiryBy: `${searchLog?.searcher?.firstName} ${
      //   searchLog?.searcher?.middleName || ""
      // } ${searchLog?.searcher?.lastName}`,
      inquiryBy: `${user.firstName || ""} ${user?.middleName || ""} ${
        user?.lastName || ""
      }`,
      inquiryDate: formatDateTime(searchLog?.createdAt),
      referenceNo: searchLog?.referenceNo,
    },
  ];

  return (
    <Document>
      <Page style={styles.page}>
        {/* Header */}
        <Text style={styles.header}>NEGATIVE RECORDS DETAIL REPORT</Text>
        <View
          style={{ display: "flex", flexDirection: "column", gap: ".25in" }}
        >
          <Info styles={styles} data={data} />
          <Info styles={styles} label="Court Case" />
          <Info styles={styles} data={[]} label="Bounce Check" />
          <Info styles={styles} data={[]} label="Watch List" />
          <Info styles={styles} data={[]} label="Telecoms" />
          <Info styles={styles} data={[]} label="Declined" />
          <Info styles={styles} data={[]} label="Delinquent" />
          <View>
            <Text>Disclamer</Text>
            <Text style={styles.disclaimer}>
              Disclaimer: This report, to be treated in strictest confidence,
              upon request and in accordance with the subscription agreement
              entered into by and between Forbes Financial Consultancy
              Corporation (FFCC) and the user, the terms of which agreement are
              hereby incorporated by reference, for exclusive use as one factor
              to be considered in connection with credit, insurance, marketing,
              and other business decisions, and for no other purpose. It may
              contain information from sources which FFCC does not control and
              which information, unless otherwise indicated, may not have been
              verified. It shall not be used as evidence in any legal proceeding
              nor shall it be shown to subject or others, and neither shall its
              source be disclosed. FFCC has acted with due diligence and in
              utmost good faith and does not guarantee the accuracy,
              completeness, and timeliness of this report or does it assume any
              part of the user's risk in its use or non-use. FFCC shall not and
              cannot be held liable for any loss, injury or damage caused or may
              hereafter be caused, directly or indirectly, by the use of the
              report or arising from the acts on the part of FFCC, its officers,
              agents, and personnel relative to the procurement, collection,
              and/or communication of any information relative thereto. Any
              point of clarification may be promptly raised solely and
              exclusively with FFCC.
            </Text>
          </View>
        </View>

        {/* Disclaimer */}
      </Page>
    </Document>
  );
};

export default function NoResultState({
  searchLog,
  user,
  onClickSaveNoRecord,
}) {
  console.log("LOGGG", searchLog);

  return (
    <div className="mt-3">
      <p>
        Search result for{" "}
        <span className="text-primary fw-semibold">
          {`${searchLog?.searched_company || ""} `}
        </span>
      </p>
      <p onClick={() => onClickSaveNoRecord(searchLog)}>
        This name does not exist in our negative records.{" "}
        <PDFDownloadLink
          document={<MyDocument searchLog={searchLog} user={user} />}
          fileName="negative_records_report.pdf"
          className="fw-semibold"
          style={{ color: "blue", cursor: "pointer" }}
        >
          {({ loading }) => (loading ? "Generating PDF..." : "Print details")}
        </PDFDownloadLink>
      </p>
    </div>
  );
}
